import styled from 'styled-components';

interface ContainerProps {
  geolocationStatus?: string;
  onlyBanner?: boolean;
}

const reverseOrder = (geolocationStatus?: string) =>
  geolocationStatus
    ? "column-reverse"
    : "column";

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: ${({geolocationStatus}) => reverseOrder(geolocationStatus)};
  ${({onlyBanner}) => onlyBanner && `header {
    display: none;
 }
`}
`
